export default {
  qstudio: {
    title: 'Introduction',
    titleP1_1:`
    Q-Studio is an atomic-scale material modeling application that is mainly used to assist users
    in preparing crystal structures before first-principles calculations. In conjunction with the cloud platform application
    `,
    titleP1_2:`
    Q-Flow , it can complete a complete set of processes from material modeling to property simulation.
    At present, Q-Studio V1.0 has officially landed on the
    `,
    titleP1_3:`
    in April 2022. Registered users can directly click the Q-Studio icon to open the application and start material modeling.
    `,
    feature1: `
    Q-Studio is developed based on the open source software Jmol, and improves the display and modeling
    functions of crystal structures on the original basis. The main functions currently include
    establishing lattices, importing local structures (supporting pwmat, cif, and vasp formats),
    exporting structures (supporting pwmat and cif formats), modifying lattice constants,
    establishing supercells, adding and deleting atoms, modifying elements, moving atoms,
    dragging atoms under symmetry restrictions, establishing supercells, and measuring distances/angles/dihedrals.
    `,
    feature2: `
    When using Q-Studio for modeling, you can directly select some atoms and create groups,
    which makes it easier to reselect atoms in the group in subsequent modeling operations, such as small molecules, clusters, etc.
    `,
    feature3: `
    As a pre-processing application, Q-Studio can directly select atoms to fix or set the initial magnetic moment,
    thereby generating a pwmat format structure file that can be read in subsequent first-principles calculations.
    `,
    feature4: `
    Q-Studio's functions are currently in a period of rapid iteration.
    New functions such as constructing surface structures, establishing vacuum layers,
    establishing adsorption systems, importing database structures, and drawing molecules will be launched in the near future.
    `,
    step1: 'Access Q-Studio through Longxun Supercomputing Cloud Platform',
    step2: 'Building the Lattice',
    step3: 'Modifying the Lattice',
    step4: 'Adding Atoms',
    step5: 'Create a supercell',
    step6: 'Moving atoms',
    step7: 'Modifying Elements',
    step8: 'Fixed Atom',
    step9: 'Create a group',

    download: 'Related Downloads',
    download1: 'PWmat Download',
    download2: 'Module Download',
    download3: 'Download Manual',
    download4: 'Pseudopotential Download',
    download5: 'Mcloud Manual',

  }
}